import { put } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { call, fork, take } from 'redux-saga/effects';
import { providerActions } from './reducer';
import { signIn } from './ProviderAPI';
import { LoginProviderFormType } from './types';
import { LoginResponseType } from './types';
import {store} from "..";
import { toastError } from '../../Methods/Helpers/ToastHelper';

function* handleLogin(payload: LoginProviderFormType) {
  try {
    const response: LoginResponseType = yield call(signIn, payload);
    if(response && response.success){
      yield put(providerActions.loginSuccess(response.data));
    }else{
      if(response.code === "UserNotConfirmedException") {
        yield put(providerActions.loginFailedWithVerificationError());
      }else{
        yield put(providerActions.loginFailed());
        yield call(toastError, response.message || "Something went wrong...");
      }
    }
  } catch (error:any) {
    yield call(toastError, error.message);
    yield put(providerActions.loginFailed());
  }
}

function* watchLoginFlow() {
  while (!store.getState().provider.isLoggedIn) {
      const action: PayloadAction<LoginProviderFormType> = yield take(providerActions.loginRequest.type);
      yield fork(handleLogin, action.payload); // Non-blocking
  }
}

function* ProviderLoginSaga() {
  yield fork(watchLoginFlow);
}

export default ProviderLoginSaga;